<template lang='pug'>
  //- TermUsage-Page
  div(:class='$style[`cc-footer-termUsage`]')
    div(:class='$style[`cc-termUsage-banner`]')
      div(:class='$style[`cc-banner-title`]')
        span.font-bold(:class='$style[`cc-banner-main-title`]')
          span.font-doctor-theme(v-html='`使`')
          span.font-normal-theme(v-html='`用`')
          span.no-wrap(v-html='`條款`')

    div(:class='$style[`cc-termUsage-container`]')
      div(:class='$style[`cc-termUsage-container-wrap`]')
        div(:class='$style[`cc-termUsage-container-wrap-list`]')
          h1.font-medium!= '一、簡介'
          div(:class='$style[`cc-termUsage-info`]')
            span!= '歡迎使用Cancell網站，為了保障您的權益，使用前請先詳讀本使用條款。'


        div(:class='$style[`cc-termUsage-container-wrap-list`]')
          h1.font-medium!= '二、本政策適用範圍'
          div(:class='$style[`cc-termUsage-info`]')
            span!= '本政策適用Cancell所有服務請<sup class="font-normal-theme">1</sup>。我們可能不定時推出新服務。若推出新服務使收集與使用個人資料的方式有變動，我們會提供變動的項目。除非推出的新服務有特別說明，否則這類服務仍須遵守本政策。'
            span.font-normal-theme!= '1. Cancell服務提供，發表留言或提問、精選文章分類、內容註冊會員(醫生及使用者)、分享個人癌友故事卡、個人喜好標籤、報名活動、醫生及使用者投稿、追隨醫生、醫生文章認同。'

        div(:class='$style[`cc-termUsage-container-wrap-list`]')
          h1.font-medium!= '三、互動與留言注意事項'
          div(:class='$style[`cc-termUsage-info`]')
            ul
              li!= '互動與留言原則嚴禁任何謾罵,請注意用字遣詞(避免使用注音文)，尊重醫師以避免不必要的糾紛。'
              li!= '請勿批評任何醫師及其他會員，如涉及人身攻擊，因無法查證，Cancell有權刪除相關內容，並將一律刪文並停權。'
              li!= 'Cancell僅供線上討論服務，不負任何法律相關責任，Q&A問答僅提供給您就醫參考意見，實際治療仍需到院所就診。'
              li!= '互動與留言前請確認已閱讀隱私政策、使用條款以免影響權益受損。'
              li!= '互動與留言請選擇適當分類來詢問，Cancell有權將提問移至適合分類或刪除。'
              li!= '轉貼任何文章或創作前請先經過原作者同意並附上出處之連結，並禁止任何廣告之訊息，經查證Cancell有權刪除提問及回覆。'
              li!= '請勿提問非癌症、醫療諮詢，Cancell以"癌症醫療"為主，廢文一律刪除及停權。'


        div(:class='$style[`cc-termUsage-container-wrap-list`]')
          h1.font-medium!= '四、如何收集個人資料'
          div(:class='$style[`cc-termUsage-info`]')
            span!= '本網站基於客戶服務，將以下方方式收集您的個人資料：'
            ul
              li!= '瀏覽網站 - 會收集瀏覽網站的使用情形，例如閱讀哪些文章、在哪些地方離開網頁、閱讀日期與時間、Cookie 資料、 IP 位址、瀏覽器類型、連線至網站的裝置類型。'
              li!= '註冊會員 - 收集個人資料，例如：姓名、電子信箱、手機、關注癌症類型，以便提供會員服務。'
              li!= '個人投稿 - 收集個人資料，例如：姓名、電子信箱、手機、個人照片、職業、著作、身分證統一編號以便與您聯絡相關事宜、編輯文稿。'
              li!= '來自Cancell - 當您在其他Cancell子網站登入使用服務時，若依據個資包括電子郵件、姓名、手機經程式比對為相同一人，我們將同步您在其他子網站使用服務的記錄。'
            span!= '來自第三方 - 我們會從與我們合作的第三方，收集有關您的個人資料。只有當您同意進行資料分享、或註冊成為會員時，我們才會使用。'


        div(:class='$style[`cc-termUsage-container-wrap-list`]')
          h1.font-medium!= '五、如何使用個人資料'
          div(:class='$style[`cc-termUsage-info`]')
            ul
              li!= '提供個人化的服務，包括內容和廣告 - 我們會用您所提供的個人資料，為您打造個人化的服務，包括個人化內容或建議文章。例如：若您在註冊時選取「肺癌」標籤，代表您對該類型有興趣，當該類型有新文章，會優先顯示在您的瀏覽頁面。'
              li!= '評估成效 - 為了了解本服務使用情形，收集並分析資料。將運用Google Analytics（分析）等多種工具分析，而分析結果將用來改善服務，提供更佳的內容。'
              li!= '互動交流 - 我們會使用向您收集到的電子郵件、手機、帳號與您互動。我們也可能在推出新服務時，寄送通知給您。'
              li!= '保護Cancell使用者和一般大眾 - 我們會應用相關資料來改善Cancell所提供服務的穩定與安全。包括：偵測與預防可能造成Cancell使用者傷害的濫用行為、安全性風險，並做出回應。'


        div(:class='$style[`cc-termUsage-container-wrap-list`]')
          h1.font-medium!= '六、分享個人資料'
          div(:class='$style[`cc-termUsage-info`]')
            span!= '以下個人資料，將會公開顯示：'
            ul
              li!= '醫生或一般使用者投稿：若您投稿本網站，一經錄用將刊登在網站，您的姓名、職業、著作將在經您同意分享的情況下，公開在投稿的文章上。一般使用者可自行選擇不公開您投稿的文章。'
              li!= '社群互動交流：當您在第三方服務註冊帳戶時（例如Facebook , Google），第三方服務會要求您建立特定的使用者名稱，依據您分享給第三方服務資料不同，所有使用本集團服務的人都看得到這個名稱以及您所張貼的任何評論。'

            span!= '我們可能會分享的資訊：'
            ul
              li!= '服務供應商：我們會與提供技術基礎架構的服務供應商合作，尤其是代管、儲存、管理及維護Cancell網站程式、內容以及我們所處理的資料的供應商，以便本網站服務順利運作。'
              li!= '合作夥伴 <a class="font-normal-theme" href="#">Cancell合作廠商列表</a>：依據您註冊Cancell服務的方式，例如透過第三方服務(Google , Facebook)，我們會視需要分享您的使用者名稱，或其他帳戶註冊資料以啟用您的帳戶。'
              li!= '執法機關：若為了遵守適用法律下的法律義務，或對搜查令、法院命令或傳票等有效的法律程序作出回應，我們將會分享您的個人資料。'


        div(:class='$style[`cc-termUsage-container-wrap-list`]')
          h1.font-medium!= '七、您的個人資料保存、刪除和權利'
          div(:class='$style[`cc-termUsage-info`]')
            span!= '依個人資料保護法，可以與Cancell聯絡請求行使以下權利：'
            ul
              li!= '查詢或請求閱覽。'
              li!= '複製。'
              li!= '補充或更正。'
              li!= '請求停止蒐集、處理或利用。'
              li!= '請求刪除。'

            span!= '上述權利之行使，本網站可能依法酌收必要成本費用，若因不符合申請程序、法律規定、本網站依法負有保存義務或法律另有規定之情況者，則可能無法依您的要求辦理。您得自由選擇是否提供相關個人資料及類別，不過我們可能也因此無法為您提供某些服務，或無法提供較佳之服務。'
            span!= '本服務可能會提供連結至其他網站或網路資源的連結。因此連結至其他網站，但不表示Cancell與該等業者有任何關係。其他業者經營的網站由各該業者自行負責，不屬Cancell控制及負責範圍之內。Cancell對任何檢索結果或外部連結，不擔保其合適性、可依賴性、即時性、有效性、正確性及完整性。您也許會檢索或連結到一些令您厭惡或不需要的網站，這是網際網路運作的可能結果，遇到此類情形時，Cancell建議您不要瀏覽或儘速離開該等網站。您同意Cancell無須為您連結至非屬於 Cancell之網站所生之任何損害，負損害賠償之責任。'


        div(:class='$style[`cc-termUsage-container-wrap-list`]')
          h1.font-medium!= '八、隱私權政策異動'
          div(:class='$style[`cc-termUsage-info`]')
            span!= 'Cancell之關係企業有權於任何時間修改或變更本政策之內容，當我們對本政策進行實質變更後，將適時依據情況向您提供重要的通知，例如發送電子郵件給您，請務必仔細閱讀任何此類通知。'


        div(:class='$style[`cc-termUsage-container-wrap-list`]')
          h1.font-medium!= '九、與我們聯絡'
          div(:class='$style[`cc-termUsage-info`]')
            span!= '如果您對Cancell服務或本協議有疑問，請利用以下方式與Cancell聯絡：'
            ul
              li.font-normal-theme!= '服務時間：週一～週五：10:00 - 18:00'
              li.font-normal-theme!= '服務信箱：'
                a.font-normal-theme(href='mailto:service@cancell.tw' target='_blank')!= 'service@cancell.tw'
              li.font-normal-theme!= '臉書粉絲專頁：'
                a.font-normal-theme(href='https://www.facebook.com/cancelltw' target='_blank')!= '@cancelltw'
              li.font-normal-theme!= '官方Line：'
                a.font-normal-theme(href='https://lin.ee/lnARn5f' target='_blank')!= 'https://lin.ee/lnARn5f'
            span!= '感謝您閱讀此條款。希望您盡情享受Cancell所提供的服務！'


</template>

<script>
export default {
  metaInfo() {
    return {
      title: '使用條款',
      titleTemplate: '%s | Cancell 醫抗癌',
      meta: [{
        name: 'og:url',
        content: 'https://cancell.tw/termUsage',
      }],
      link: [{
        rel: 'canonical',
        href: 'https://cancell.tw/termUsage',
      }],
    };
  },

  // data () {
  //   return {
  //   }
  // },

  // methods: {},
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/footer/termUsage.scss';
</style>
